<ion-content [fullscreen]="true" *ngIf="provider$ | async as provider">

  <app-header [provider]="provider"></app-header>

  <ng-container *ngIf="service$ | async as category">

    <!--    <pre style="position: absolute;top:50px;background: rgba(255,255,255,0.5)">-->
    <!--    {{hasVisibleServices(category)}}-->
    <!--      {{hasSomeServices(category)}}-->
    <!--&lt;!&ndash;      {{category | json}}&ndash;&gt;-->
    <!--    </pre>-->
    <div class="content nopadding">
      <div class="bigblock yellow">
        <div class="vertical">{{ category?.parentName }}</div>
        <div class="text preformatted-text">
          <h1>{{ category?.name }}</h1>
          {{ category?.shortDescription }}
        </div>
        <img src="{{ category?.avatar?.url || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"
          alt="{{category?.name}} - {{category?.shortDescription}} | dm Studio">
        <div class="down"></div>
      </div>
    </div>


    <ng-container
      *ngIf="category && category.children && category.children.length > 0 && category.children[0].children && category.children[0].children.length > 0">
      <div class="content nopadding" *ngFor="let subcategory of category?.children">
        <div class="items mt-30" *ngIf="hasVisibleServices(subcategory)">
          <h2 class="left mb-40" style="text-transform: uppercase;">{{subcategory?.name}}</h2>
          <div class="flex">

            <app-service-card class="clickable item blue"
              *ngFor="let service of subcategory!.children | onlyServices | onlyVisibleForCustomer" [service]="service"
              [style.border-color]="service.borderColor" [style.--bg-color]="service.borderColor + '2A'"></app-service-card>

          </div>
        </div>
      </div>
    </ng-container>

    <!-- TODO check why this part is improtant and how to overcome limitations on strizenje-->
    <ng-container *ngIf="hasVisibleServices(category) ">
      <div class="content nopadding">
        <div class="items mt-30">
          <div class="flex">
            <app-service-card class="clickable item blue" *ngFor="let service of category!.children | onlyServices | onlyVisibleForCustomer"
              [service]="service" [style.border-color]="service.borderColor" [style.--bg-color]="service.borderColor + '2A'"
              [categorySlug]="category.slug"></app-service-card>
          </div>
        </div>
      </div>
    </ng-container>

    <!--div class="content nopadding">
      <div class="items mt-30">
        <h2 class="left mb-40">OTROŠKI IN MLADINSKI KOTIČEK</h2>
        <div class="flex">
          <div class="item blue"><div class="new">NOVO</div><div class="img"><img src="assets/img/item_1.png"></div><div class="vertical">FRIZERSKE STORITVE</div><b>Žensko striženje - do ramen</b><div class="bag"></div><div class="desc">Svetovanje, umivanje, striženje, oblikovanje las s sušilnikom, likalnikom ali kodralnikom in oblikovanje pričeske z izdelki za oblikovanje las.</div><div class="discount">50 EUR</div><div class="price"><span>42</span> EUR</div></div>
          <div class="item yellow"><div class="img"><img src="assets/img/item_2.png"></div><div class="vertical">FRIZERSKE STORITVE</div><b>Barvanje narastka - lasje do ramen</b><div class="bag"></div><div class="desc">Svetovanje, umivanje, striženje, oblikovanje las s sušilnikom, likalnikom ali kodralnikom in oblikovanje pričeske z izdelki za oblikovanje las.</div><div class="discount"></div><div class="price"><span>55</span> EUR</div></div>
          <div class="item blue"><div class="img"><img src="assets/img/item_3.png"></div><div class="vertical">FRIZERSKE STORITVE</div><b>Fen frizura - lasje od ramen</b><div class="bag"></div><div class="desc">Svetovanje, umivanje, striženje, oblikovanje las s sušilnikom, likalnikom ali kodralnikom in oblikovanje pričeske z izdelki za oblikovanje las.</div><div class="discount"></div><div class="price"><span>55</span> EUR</div></div>
          <div class="item blue"><div class="new">NOVO</div><div class="img"><img src="assets/img/item_1.png"></div><div class="vertical">FRIZERSKE STORITVE</div><b>Žensko striženje - do ramen</b><div class="bag"></div><div class="desc">Svetovanje, umivanje, striženje, oblikovanje las s sušilnikom, likalnikom ali kodralnikom in oblikovanje pričeske z izdelki za oblikovanje las.</div><div class="discount">50 EUR</div><div class="price"><span>42</span> EUR</div></div>
        </div>
      </div>
    </div-->

    <!-- <div class="content" *ngIf="consultationService as service">
      <div class="midblock mt-50">
        <img src="{{service.avatar?.url}}">
        <div class="text">
          <div class="vertical">REZERVIRAJ TERMIN</div>
          <b>{{service.name}}</b>
          <span>{{service.longDescription}}</span>
          <a class="shop mt-30 clickable" (click)="cartService.addService(service)"><b></b>DODAJ V KOŠARICO</a>
        </div>
      </div>
    </div> -->


    <app-brands></app-brands>

  </ng-container>

  <app-footer [provider]="provider"></app-footer>

  <app-cart [provider]="provider"></app-cart>

</ion-content>